export function buildSlotCache(schedule, context) {
  const nextCache = {};
  if (!Array.isArray(schedule)) {
    return nextCache;
  }

  const resourceId = context && context.resourceId !== undefined ? context.resourceId : null;
  const resourceName = context && context.resourceName ? context.resourceName : null;
  const preferredDurationRaw = context && context.preferredDuration !== undefined && context.preferredDuration !== null
    ? Number(context.preferredDuration)
    : null;
  const preferredDuration = Number.isFinite(preferredDurationRaw) ? preferredDurationRaw : null;

  schedule.forEach((day) => {
    if (!day || typeof day !== 'object') {
      return;
    }

    const date = typeof day.date === 'string' ? day.date.trim() : null;
    if (!date) {
      return;
    }

    const slotsSource = Array.isArray(day.slots) ? day.slots : [];
    let normalizedSlots;

    if (slotsSource.length) {
      normalizedSlots = slotsSource
        .map((slot) => normalizeSlotFromSchedule(day, slot, {
          resourceId,
          resourceName,
          preferredDuration,
        }))
        .filter(Boolean);
    } else {
      const times = Array.isArray(day.times) ? day.times : [];
      normalizedSlots = times
        .map((time) => buildFallbackSlot(day, time, {
          resourceId,
          resourceName,
          preferredDuration,
        }))
        .filter(Boolean);
    }

    nextCache[date] = normalizedSlots || [];
  });

  return nextCache;
}

function normalizeSlotFromSchedule(day, slot, context) {
  if (!slot || typeof slot.time !== 'string') {
    return null;
  }

  const durations = Array.isArray(slot.durations)
    ? slot.durations
        .map((item) => Number(item && item.duration !== undefined ? item.duration : item))
        .filter((value) => Number.isFinite(value) && value > 0)
    : [];

  const priceByDuration = {};

  const preferedDuration = Number.isFinite(Number(slot.preferedDuration))
    ? Number(slot.preferedDuration)
    : (context && context.preferredDuration !== null ? context.preferredDuration : null);

  return {
    date: day && day.date ? day.date : null,
    time: slot.time,
    durations,
    preferedDuration,
    isAvailable: true,
    resourceId: context && context.resourceId !== undefined ? context.resourceId : null,
    resourceName: context && context.resourceName ? context.resourceName : null,
    raw: slot,
    priceByDuration,
  };
}

function buildFallbackSlot(day, time, context) {
  if (!time) {
    return null;
  }

  const normalizedTime = typeof time === 'string' ? time.trim() : null;
  if (!normalizedTime) {
    return null;
  }

  return {
    date: day && day.date ? day.date : null,
    time: normalizedTime,
    durations: [],
    preferedDuration: context && context.preferredDuration !== undefined ? context.preferredDuration : null,
    isAvailable: true,
    resourceId: context && context.resourceId !== undefined ? context.resourceId : null,
    resourceName: context && context.resourceName ? context.resourceName : null,
    raw: {
      time: normalizedTime,
      durations: [],
    },
    priceByDuration: {},
  };
}

export function collectSlotDurations(slotInfo) {
  if (!slotInfo) {
    return [];
  }

  const durations = [];

  if (Number.isFinite(slotInfo.preferedDuration) && slotInfo.preferedDuration > 0) {
    durations.push(Number(slotInfo.preferedDuration));
  }

  if (Array.isArray(slotInfo.durations)) {
    slotInfo.durations.forEach((value) => {
      const numeric = Number(value);
      if (Number.isFinite(numeric) && numeric > 0 && !durations.includes(numeric)) {
        durations.push(numeric);
      }
    });
  }

  return durations;
}

export function formatDurationPrompt(dateIso, time) {
  if (!dateIso || !time) {
    return '';
  }

  try {
    const dateObj = new Date(`${dateIso}T00:00:00`);
    const formattedDate = dateObj.toLocaleDateString(undefined, {
      weekday: 'short',
      day: '2-digit',
      month: 'short',
    }).replace('.', '');
    return `${formattedDate} · ${time}`;
  } catch (error) {
    return `${dateIso} ${time}`;
  }
}
